import Footer from "./Component/Footer";
import MenuBar from "./Component/MenuBar";
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';
const ActivityCalendar = () => {
    return (
        <>

     <Helmet>
        <title> Yugalkunj Canada Hamilton </title>
          <meta name="description" content="Join our exciting Summer Camp in Hamilton 2024! Fun-filled activities, learning opportunities, and memorable experiences for kids of all ages." />
          <meta name="keywords" content="Summer camp Hamilton 2024, Summer camp 2024, summer camp, Hamilton, 2024, kids activities, outdoor fun, learning, education" />
          <meta name="author" content="Yugalkunj Canada Hamilton" />
        <link rel="canonical" href="https://yugalkunj.org/Canada/Camps/Summer_Camp_Hamilton" />
      </Helmet>

            <MenuBar />
            {/* <!-- Page Banner Section --> */}
            <section className="page-banner">
                <div className="image-layer"></div>

                <div className="auto-container">
                    <h1>Activity Calendar</h1>
                </div>

                <div className="breadcrumb-box">
                    <div className="auto-container">
                        <ul className="bread-crumb clearfix">
                            <li><Link to='/CAD/Home'>Home</Link></li>
                            <li className="active">Activity Calendar</li>
                        </ul>
                    </div>
                </div>

            </section>
            {/* <!--End Banner Section --> */}

            {/* <!--FAQs Section--> */}
            <section className="faq-section">
                <div className="auto-container">

                    <div className="row clearfix">

                        <div className="col-md-12">
                            <img src="https://yugalkunj.org/images/ca_calendar.jpg" className="img-round " style={{ border: '1px solid #ccc', width:"90%" }} alt="yk calender" />

                            {/* <!-- <iframe id="gcalendar_frame" src="https://www.google.com/calendar/embed?showTitle=1&amp;showNav=1&amp;showDate=1&amp;showPrint=1&amp;showTabs=1&amp;showCalendars=0&amp;showTz=1&amp;mode=MONTH&amp;wkst=2&amp;bgcolor=%23FFFFFF&amp;hl=&amp;ctz=America/New_York&amp;height=500&amp;src=i4ot1nkv9bsnvk34bikit77vks@group.calendar.google.com&amp;color=%23A32929&amp;src=i4ot1nkv9bsnvk34bikit77vks@group.calendar.google.com&amp;color=%23B1440E" width="100%" height="500" align="top" frameborder="0" className="gcalendar"> </iframe> -->  */}
                        </div>


                    </div>


                </div>
            </section>






            <Footer />


        </>


    )



}

export default ActivityCalendar;